export default __webpack_public_path__ + "static/media/Health.b0436933.svg";